export function getBuilder (state) {
  return state.builderData
}

export function getHighlightComment (state) {
  return state.highlightComment
}

export function getComments (state) {
  return state.comments
}

export function getSubmissions (state) {
  return state.submissions
}



// WEBPACK FOOTER //
// ./src/vuex/builder/getters.js